import axios from '../axios';

const fetchProjectMedia = async (projectId: string) => {
  const { data } = await axios.get(`/media/${projectId}`);

  return data;
};

export default fetchProjectMedia;
